<template>
  <div class="fanshui-detail">
    <div class="header">
      <div class="back" @click="$router.back()">
        <van-icon name="arrow-left" color="#BEBEBE" size="16"/>
      </div>
      <div class="header-title">返水比例</div>
      <div class="header-right"></div>
    </div>

    <div class="filter-bar">
      <div class="filter-item" @click="showGameType = !showGameType">
        <span>{{ gameTypeOptions[gameType].text }}</span>
        <van-icon name="arrow-down" size="12" />
        <div class="filter-dropdown" v-show="showGameType">
          <div v-for="(opt, idx) in gameTypeOptions" :key="idx" 
               class="filter-option" :class="{ active: gameType === idx }"
               @click="gameType = idx; showGameType = false;">{{ opt.text }}</div>
        </div>
      </div>
      <div class="filter-item" @click="showPlatform = !showPlatform">
        <span>{{ platformOptions[platform].text }}</span>
        <van-icon name="arrow-down" size="12" />
        <div class="filter-dropdown" v-show="showPlatform">
          <div v-for="(opt, idx) in platformOptions" :key="idx" 
               class="filter-option" :class="{ active: platform === idx }"
               @click="platform = idx; showPlatform = false;">{{ opt.text }}</div>
        </div>
      </div>
      <div class="filter-label">累计洗码</div>
      <div class="filter-label">返水比例</div>
    </div>

    <div class="table-container">
      <div class="table-body">
        <div class="table-row" v-for="(item, index) in tableList" :key="index">
          <div class="td">{{ item.category }}</div>
          <div class="td">{{ item.platform }}</div>
          <div class="td">{{ item.washCode }}</div>
          <div class="td rate">{{ item.rate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fanshuiDetail',
  data() {
    return {
      gameType: 0,
      platform: 0,
      showGameType: false,
      showPlatform: false,
      gameTypeOptions: [
        { text: '电子', value: 0 },
        { text: '棋牌', value: 1 },
        { text: '捕鱼', value: 2 },
        { text: '真人', value: 3 },
        { text: '体育', value: 4 },
        { text: '区块链', value: 5 },
        { text: '电竞', value: 6 },
      ],
      platformOptions: [
        { text: 'PG', value: 0 },
        { text: 'AG', value: 1 },
        { text: '其他', value: 2 },
      ],
      tableList: [
        { category: '电子', platform: 'PG', washCode: '≥1+', rate: '1.00%' },
        { category: '电子', platform: 'PG', washCode: '≥1+', rate: '1.00%' },
        { category: '电子', platform: 'PG', washCode: '≥1,000.00+', rate: '1.20%' },
        { category: '电子', platform: 'PG', washCode: '≥3,000.00+', rate: '1.50%' },
        { category: '电子', platform: 'PG', washCode: '≥5,000.00+', rate: '2.00%' },
        { category: '电子', platform: 'PG', washCode: '≥10,000.00+', rate: '2.50%' },
        { category: '电子', platform: 'PG', washCode: '≥100,000.00+', rate: '5.00%' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.fanshui-detail {
  min-height: 100vh;
  background: #1E1F24;
  padding-top: 44px;

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 44px;
    background: #292A2C;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    z-index: 100;

    .back {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .header-title {
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      flex: 1;
      text-align: center;
    }

    .header-right {
      width: 44px;
    }
  }

  .filter-bar {
    background: #292A2C;
    padding: 10px 15px;
    display: flex;
    justify-content: space-around;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 8px 12px;
      background: #1E1F24;
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      position: relative;

      .filter-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #292A2C;
        border-radius: 4px;
        overflow: hidden;
        z-index: 100;

        .filter-option {
          padding: 10px;
          text-align: center;
          font-size: 12px;
          color: #888;

          &.active {
            color: #DFB372;
            background: rgba(223, 179, 114, 0.1);
          }
        }
      }
    }

    .filter-label {
      font-size: 12px;
      color: #fff;
      display: flex;
      align-items: center;
    }
  }

  .table-container {
    padding: 10px 15px;

    .table-body {
      background: #1E1F24;
      border-radius: 4px;

      .table-row {
          display: flex;
          padding: 10px;
          border-bottom: 1px solid #3B3C3D;

          &:last-child {
            border-bottom: none;
          }

          .td {
            flex: 1;
            text-align: center;
            font-size: 12px;
            color: #999;
          }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fanshuiDetail.vue